/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Part_2_DInputs */

const en_tut_part_2_d = /** @type {(inputs: Tut_Part_2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where work is recorded, discussed, written down, and found again.`)
};

const id_tut_part_2_d = /** @type {(inputs: Tut_Part_2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempat pekerjaan dicatat, dibicarakan, ditulis, dan dicari kembali.`)
};

/**
* | output |
* | --- |
* | "Where work is recorded, discussed, written down, and found again." |
*
* @param {Tut_Part_2_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_part_2_d = /** @type {((inputs?: Tut_Part_2_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Part_2_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_part_2_d(inputs)
	return en_tut_part_2_d(inputs)
});